<template>
    <v-dialog persistent v-model="dialog" width=25%>
        <v-card class="px-2">
            <v-container>
                <div class="row-pointer" v-if="taak.taak_encrid === ''">
                    <v-row class="pa-4">
                        <h3>Add task</h3>
                    </v-row>
                    <v-row class="mb-6"><v-divider></v-divider></v-row>
                </div>
                <div class="row-pointer" v-else>
                    <v-row class="pa-4">
                        <h3>Update task (description)</h3>
                    </v-row>
                    <v-row><v-divider></v-divider></v-row>
                </div>

                <v-row dense class="mt-5 pl-4 pr-6" v-if="taak.taak_encrid === ''">
                    <v-col cols=12>
                        <v-form v-model="taak_valid">
                            <v-text-field v-model="taak.taak_code" required label="Task code" :rules="codeRules">{{ taak.taak_code }}</v-text-field>
                        </v-form>
                    </v-col>
                </v-row>
                <v-row dense class="mt-5 pl-4 pr-6" v-else>
                    <v-col cols=12>
                        {{ taak.taak_code }}
                    </v-col>
                </v-row>
                <v-row dense class="pl-4 pr-6">
                    <v-col cols=12>
                        <v-form>
                            <v-textarea v-model="taak.taak_prog" rows="3" required label="Task program(s)">{{ taak.taak_prog }}</v-textarea>
                        </v-form>
                    </v-col>
                </v-row>
                <v-row dense class="pl-4 pr-6">
                    <v-col cols=12>
                        <v-form>
                            <v-textarea v-model="taak.taak_oms" rows="3" required label="Task description">{{ taak.taak_oms }}</v-textarea>
                        </v-form>
                    </v-col>
                </v-row>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" small :disabled="!taak_valid" v-on:click="addUpdTaak()">Save</v-btn>
                    <v-btn color="primary" small v-on:click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    data() {
        return {
            dialog: false,
            taak_valid: false,
            taak: this.newTaak(""),
            codeRules: [
                v => !!v || "A value for code is required"
            ]
        }
    },

    methods: {
        newTaak(encrid) {
            return {
                taak_encrid: encrid,
                taak_code: "",
                taak_prog: "",
                taak_oms: "",
                taak_used: 0,
            }
        },
        open(taak_encrid) {
            this.taak = this.newTaak(taak_encrid);
            this.taak_valid = false;

            if (taak_encrid !== "") {
                this.taak_valid = true;
                this.getTaak();
            } else {
                this.dialog = true;
            }
        },
        getTaak() {
			this.$axios.post("ares/json/ares/syst/authorization/getTaak.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getTaak"
                },
                getTaak: {
                    taak_encrid: this.taak.taak_encrid
                }
            }).then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                    this.dialog = false;
                } else {
                    this.taak = res.data.getTaak[0];
                    this.dialog = true;
                }
            });
		},
        addUpdTaak() {
            // let add_upd_data = {
            //     taak_encrid: this.taak_encrid,
            //     taak_code: this.taak.taak_code,
            //     taak_oms: this.taak_oms,
            // }
            // console.log(add_upd_data)
            if (this.taak.taak_encrid === "") {
                this.$axios.post("ares/json/ares/syst/authorization/addTaak.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addTaak"
                    },
                    addTaak: this.taak
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.closeDialog();                       
                    }
                }).finally();
            } else {
                this.$axios.post("ares/json/ares/syst/authorization/updTaak.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updTaak"
                    },
                    updTaak: this.taak
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.closeDialog();                       
                    }
                }).finally();
            }
        },
		closeDialog(){
            this.$emit("updateData", "refresh");
			this.dialog = false;
		}
    }
}
</script>

<style scoped>
    .row-pointer {
        cursor: default;
    }
</style>